/* eslint-disable functional/no-conditional-statement */
import { fetchDeleteCart } from "../../cart/miscellaneous/fetchDeleteCart";
import { deleteCookie } from "../../payment/miscellaneous/deleteCookie";
import { fetchGetOrders } from "./fetchGetOrders";
import { OrderState } from "./orderAtom";
import { RequestOrderOutput } from "./requestOrder";

export async function requestOrders(
  order: OrderState
): Promise<RequestOrderOutput> {
  const orders = await fetchGetOrders();

  if (orders.tag === "data-error") {
    fetchDeleteCart()
      .then((result) => {
        if (result.tag === "successful") {
          deleteCookie("MkHcOrderLineCount");

          window.location.reload();
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  const found = orders.tag === "successful" ? orders.parsed ?? null : null;
  return {
    tag: orders.tag,
    order: found === null ? order : found,
  };
}
